import AddressDTO from "features/customer/dtos/AddressDTO";
import { Country } from "../enums/country";
import AddressFindEnumDTO from "features/shared/enums/dynamic/AddressFindEnumDTO";
import { containsKey } from "./objects";

export interface FormattedAddress {
  streetSection: string;
  citySection: string;
  countryCodeSection: string;
}

export const getAddressSections = (address?: AddressDTO): FormattedAddress => {
  return {
    streetSection: getStreetSection(address),
    citySection: getCitySection(address),
    countryCodeSection: getCountrySection(address)
  };
}

export const getStreetSection = (address?: AddressDTO | AddressFindEnumDTO) => {
  let steetSection = "";
  if (address) {
    let evidenceNum = getLandRegistryOrEvidenceNumber(address);
    let houseNum = address.houseNumber ? (evidenceNum ? `/${address.houseNumber}`: address.houseNumber) : "";
    steetSection = `${address.street ?? ""} ${evidenceNum}${houseNum}`;
  }

  return steetSection;
}

export const getCitySection = (address?: AddressDTO | AddressFindEnumDTO) => {
  let citySection = "";
  if (address) {
    let cityText = address.city ? address.city : "";
    let cityPartText = address.cityPart && address.cityPart !== address.city ? `-${address.cityPart}` : "";
    
    citySection = `${getFormattedZipCode(address.zipCode, address.countryCode as Country)} ${cityText}${cityPartText}`;
  }

  return citySection;
}

export const getCountrySection = (address?: AddressDTO) => {
  return address && address.countryCode ? address.countryCode.toString() : "";
}

export const getFormattedZipCode = (zipCode?: string, country?: Country) => {
  let resultZip = "";

  if (
    zipCode &&
    zipCode.length === 5 &&
    (country == Country.CZ || country == Country.SK)
  ) {
    resultZip = `${zipCode.substring(0, 3)} ${zipCode.substring(3, 5)}`;
  } else if (zipCode) {
    resultZip = zipCode;
  }

  return resultZip;
}

export const getLandRegistryOrEvidenceNumber = (address: AddressDTO | AddressFindEnumDTO): string => {
  // land registry number - cislo popisne
  if (containsKey(address, "landRegistryNumber") && (address as AddressDTO).landRegistryNumber) {
    return (address as AddressDTO).landRegistryNumber!;
  }

  // evidence number - evidencni cislo
  let evidenceNum = address.evidenceNumber ? address.evidenceNumber : "";

  if (containsKey(address, "evidenceNumberType") &&
    (address as AddressFindEnumDTO).evidenceNumberType === "CisloEvidencni" &&
    evidenceNum !== ""
  ) {
    evidenceNum = `ev. ${evidenceNum}`;
  }

  return evidenceNum;
}